import { render, staticRenderFns } from "./PublicationCitesForm.vue?vue&type=template&id=5ebee89e&scoped=true"
import script from "./PublicationCitesForm.vue?vue&type=script&lang=js"
export * from "./PublicationCitesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ebee89e",
  null
  
)

export default component.exports